/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 6/10/2020
 */

export const FormTypeEnum = Object.freeze({
	GENERAL: "GENERAL_FORM",
	INTAKE_FORM: "INTAKE_FORM",
	PREP_FORM: "PREP_FORM",
	POST_FORM: "POST_FORM",
})
